import { render } from "./TicketDetail.vue?vue&type=template&id=09f21736&scoped=true"
import script from "./TicketDetail.vue?vue&type=script&lang=js"
export * from "./TicketDetail.vue?vue&type=script&lang=js"

import "./TicketDetail.vue?vue&type=style&index=0&id=09f21736&scoped=true&lang=css"

import exportComponent from "F:\\stsworkspace\\gil\\yongpyong-mobile-service-main\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09f21736"]])

export default __exports__